import * as _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

import FormBoxes from "../../../../../../utils/forms/components/FormBoxes";

/* Load Redux Store */
import { ActionCreator } from "../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../actions/actionCreators";
import { configurationsStoreSelectors } from "../../../../store/store";

/* Load Forms */
import { accountingConfigBox } from "./FormBuild/AccountingConfiguration.forms";
import { defaultValues } from "./FormBuild/AccountingConfiguration.defaults";
import { ACCOUNTING_SYSTEM_DICT } from "./FormBuild/AccountingConfiguration.constants";

import "./AccountingConfigurationSection.component.scss";
import { ConfigurationsActionTypes } from "../../../../actions/actionTypes";
import { CurrenciesList } from "../../../../reducers/currencies.reducer";
import { subsidiaryDenominations } from "../../../../../../utils/addressUtils";

export interface AccountingConfigurationSectionProps {
    updateAccountingConfig: ActionCreator;
    configSectionVisited: ActionCreator;
    basicConfig: any;
    accountingConfig: any;
    accountingSchema: any;
    schemaLoading: boolean;
    editingConfigurationLoading: boolean;
    currenciesList: CurrenciesList;
    getProductionServer: ActionCreator;
    productionServer: any;
    productionServerLoading: boolean;
}

class AccountingConfigurationSection extends Component<
    AccountingConfigurationSectionProps,
    {}
> {
    private previousFormValues = null;
    private updateForm = 0
    private accepted_coins = []
    private accepted_bills = []

    componentDidMount() {
        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_ACCOUNTING_CONFIG
        );
        this.props.getProductionServer()
    }

    onFormChange = props => {
        if (
            !this.props.schemaLoading &&
            !this.props.editingConfigurationLoading &&
            !this.props.productionServerLoading
            //&&
            // !_.isEqual(props.values, this.previousFormValues)
        ) {
            let values = { ...props.values };
            if(!(values.expiration_type == 0 || values.expiration_type == 1 || values.expiration_type == null)) {
                values.expiration_time = null
            }

            if (
                this.previousFormValues &&
                this.previousFormValues.use_4_digit_gistra == true &&
                props.values.voucher_digits != 4
            ) {
                values = { ...props.values, use_4_digit_gistra: false };
            }
            if (
                this.previousFormValues &&
                this.previousFormValues.system !== values.system
            ) {
                values = { system: values.system };
                this.updateForm ++
            }

            if(props.values && props.values.hasOwnProperty("accepted_coins")){
                this.accepted_coins = props.values.accepted_coins
            }
            if(props.values && props.values.hasOwnProperty("accepted_bills")){
                this.accepted_bills = props.values.accepted_bills
            }

            this.previousFormValues = _.cloneDeep(props.values);
            //Provider = Gistra ou Intimus: voucher_digits = 18
            if (props.values.provider == 30 || props.values.provider == 32) {
                values = {
                    ...props.values,
                    voucher_digits: 18,
                    expiration_type:
                        props.values.expiration_type == 3
                            ? null
                            : props.values.expiration_type
                };
            }
            //Provider = AMYC: voucher_digits = 13
            else if (props.values.provider == 33) {
                values = {
                    ...props.values,
                    voucher_digits: 13,
                    expiration_type: 1
                };
            }

            if (props.values.provider != 33 && props.values.voucher_digits == 13) {
                values = {
                    ...props.values,
                    voucher_digits: 4
                };
            }

            //Provider != TITO FBM: External provider = null
            if ((props.values.provider != 25 || props.values.voucher_digits != 4) && props.values.external_provider) {
                values = {
                    ...props.values,
                    external_provider: null
                };
            }

            if (
                (props.values.system != 2 ||
                props.values.provider != 25 ||
                props.values.voucher_digits != 18) &&
                "has_prefix_code" in props.values &&
                "prefix_code" in props.values
            ){
                delete values.has_prefix_code
                delete values.prefix_code
            }

            if ("has_prefix_code" in values &&
                !values.has_prefix_code &&
                "has_prefix_code" in props.values &&
                "prefix_code" in props.values) {
                values.prefix_code = null;
            }

            this.props.updateAccountingConfig({
                config: values,
                isValid: props.isValid
            });
        }
    };

    render() {
        if (this.props.editingConfigurationLoading || this.props.productionServerLoading) {
            return (
                <div className="loading" key="loading">
                    <Components.LoadingRipple width={100} height={100} />
                </div>
            );
        } else {
            let emptyAccount = true;
            Object.keys(this.props.accountingConfig).map(key => {
                if (
                    this.props.accountingConfig[key] !== null &&
                    this.props.accountingConfig[key] !== undefined
                ) {
                    emptyAccount = false;
                }
            });

            let defaults = !emptyAccount
                ? this.props.accountingConfig
                : defaultValues({
                      schema: this.props.accountingSchema
                  });

            if (
                !emptyAccount &&
                Object.keys(this.props.accountingConfig).length == 1 &&
                this.props.accountingConfig.hasOwnProperty("system")
            ) {
                const accountSystem = ACCOUNTING_SYSTEM_DICT.find(
                    system => system.value == this.props.accountingConfig.system
                );

                if (accountSystem) {
                    defaults = {
                        ...defaultValues({
                            schema: {
                                ...this.props.accountingSchema,
                                properties: {
                                    ...this.props.accountingSchema.properties,
                                    ...(this.props.accountingSchema.definitions &&
                                  this.props.accountingSchema.definitions["$".concat(accountSystem.label.toLocaleLowerCase())]
                                  ? this.props.accountingSchema.definitions["$".concat(accountSystem.label.toLocaleLowerCase())].properties
                                  : {})
                                },
                                required: {
                                    ...this.props.accountingSchema.required,
                                    ...(this.props.accountingSchema.definitions &&
                                  this.props.accountingSchema.definitions["$".concat(accountSystem.label.toLocaleLowerCase())]
                                  ? this.props.accountingSchema.definitions["$".concat(accountSystem.label.toLocaleLowerCase())].required
                                  : {})
                                }
                            }
                        }),
                        ...this.props.accountingConfig
                    };

                    if(defaults.hasOwnProperty("accepted_coins")) {
                        defaults.accepted_coins = this.accepted_coins
                    }
                    if(defaults.hasOwnProperty("accepted_bills")) {
                        defaults.accepted_bills = this.accepted_bills
                    }
                }
            }
            return (
                <div id="AccountingConfigurationSection" key={this.updateForm}>
                    <FormBoxes
                        key={`${
                            this.props.accountingConfig &&
                            this.props.accountingConfig.system
                                ? this.props.accountingConfig.system+'_'+this.props.accountingConfig.provider
                                : "acc"+'_'+this.props.accountingConfig.provider
                        }`}
                        boxes={accountingConfigBox({
                            system: this.props.accountingConfig
                                ? this.props.accountingConfig.system
                                : null,
                            expiration: this.props.accountingConfig
                                ? this.props.accountingConfig["expiration_type"]
                                : null,
                            provider:
                                this.props.accountingConfig &&
                                this.props.accountingConfig.system == 2
                                    ? this.props.accountingConfig["provider"]
                                    : null,
                            voucher:
                                this.props.accountingConfig &&
                                this.props.accountingConfig.system == 2
                                    ? this.props.accountingConfig[
                                          "voucher_digits"
                                      ]
                                    : null,
                            accountingSchema: this.props.accountingSchema,
                            hasPrefixCode: this.props.accountingConfig &&
                                this.props.accountingConfig.system == 2 &&
                                this.props.accountingConfig.provider == 25 &&
                                this.props.accountingConfig.voucher_digits == 18
                                    ? this.props.accountingConfig[
                                          "has_prefix_code"
                                      ]
                                    : null,
                            accepted_coins: this.props.currenciesList.accepted_coins.map(coin =>{
                                                return {
                                                    label: subsidiaryDenominations[this.props.basicConfig.country.toUpperCase()]((coin / 100).toString()),
                                                    value: coin
                                                }
                                            }),
                            accepted_bills: this.props.currenciesList.accepted_bills.map(coin =>{
                                                return {
                                                    label: subsidiaryDenominations[this.props.basicConfig.country.toUpperCase()]((coin / 100).toString()),
                                                    value: coin
                                                }
                                            }),
                            hasTITOSystem: !(this.props.productionServer && (this.props.basicConfig.country === 'MX' || this.props.basicConfig.country === 'US' || this.props.basicConfig.country === 'BR'))
                        })}
                        onChange={this.onFormChange}
                        validateOnUpdate={true}
                        initialValues={defaults}
                        isConfig={true}
                    />
                </div>
            );
        }
    }
}

const mapStateToProps = state => ({
    basicConfig: configurationsStoreSelectors.basicConfig(state),
    accountingConfig: configurationsStoreSelectors.accountingConfig(state),
    accountingSchema: configurationsStoreSelectors.accountingSchema(state),
    schemaLoading: configurationsStoreSelectors.schemaLoading(state),
    editingConfigurationLoading:
        configurationsStoreSelectors.editingConfigurationLoading(state),
    currenciesList: configurationsStoreSelectors.currenciesList(state),
    productionServer: configurationsStoreSelectors.productionServer(state),
    productionServerLoading: configurationsStoreSelectors.productionServerLoading(state)
});

const mapDispatchToProps = {
    updateAccountingConfig: ConfigurationsActionCreators.updateAccountingConfig,
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited,
    getProductionServer: ConfigurationsActionCreators.getProductionServer
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountingConfigurationSection);
